import React from 'react';
import Intro from '../components/Intro';

export default function Home(): React.ReactElement {
    return (
        <section>
            <Intro />
        </section>
    );
}
